import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { MarkerCapShortFormatted } from '@root/shared/core/format'

import type { PairModel } from '@root/entities/pair'

type Props = {
  pair: PairModel
}

export const CreatorPairsTableAthCell: React.FC<Props> = ({ pair }) => {
  const [athMarketCap] = useAtom(pair.athMarketCap)

  return (
    <Root>
      <MarkerCapShortFormatted mcap={athMarketCap} />
    </Root>
  )
}

const Root = styled.div`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: var(--amber-9);
  white-space: nowrap;
`
